import api from '@/services/api'
// eslint-disable-next-line no-undef
import { defineStore } from 'pinia'
import { useDataStore } from '@/stores/data'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    user: null,
    stravaConnected: false,
    stravaSynced: false
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
    isStravaConnected: (state) => state.stravaConnected,
    isStravaSynced: (state) => state.stravaSynced,
    isAdmin: (state) => !!(state.user && state.user.is_admin)
  },
  actions: {
    async initialize() {
      const token = localStorage.getItem('token')
      if (token) {
        this.token = token
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        await this.fetchUser()
      }
    },
    async loginWithGoogle(googleToken) {
      console.log('Google token:', googleToken)
      // Note: Token appears to be authorization code, not access token
      // Email is extracted by API from token
      try {
        // First try login
        let response = await api.post('/api/user/login_google', {
          google_access_token: googleToken,
          web: 1
        })
        if (response.status === 200) {
          this.setToken(response.data.token)
          await this.fetchUser()
          await this.loadUserData()
          return true
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // If login fails, try register
          try {
            const registerResponse = await api.post('/api/user/register_google', {
              google_access_token: googleToken,
              web: 1
            })
            if (registerResponse.status === 201) {
              // After register, login again
              const loginResponse = await api.post('/api/user/login_google', {
                google_access_token: googleToken,
                web: 1
              })
              this.setToken(loginResponse.data.token)
              await this.fetchUser()
              await this.loadUserData()
              return true
            }
          } catch (registerError) {
            throw new Error('Registration failed')
          }
        } else {
          throw new Error('Login failed')
        }
      }
      return false
    },
    setToken(token) {
      this.token = token
      localStorage.setItem('token', token)
    },
    async fetchUser() {
      try {
        const response = await api.get('/api/user')
        this.user = response.data
        // Check Strava connection status
        this.stravaConnected = !!(this.user && this.user.strava_id)
        this.stravaSynced = !!(this.user && this.user.strava_synced)
        console.log('User data:', this.user)
        console.log('Strava connected:', this.stravaConnected, 'Synced:', this.stravaSynced)
        console.log('strava_id value:', this.user?.strava_id)
      } catch (error) {
        console.error('Failed to fetch user data:', error)
        // Don't logout here as token might still be valid
      }
    },
    async loadUserData() {
      try {
        const dataStore = useDataStore()
        await dataStore.loadAllData()
      } catch (error) {
        console.error('Failed to load user data:', error)
      }
    },
    logout() {
      this.token = null
      this.user = null
      localStorage.removeItem('token')
      // Clear user data
      const dataStore = useDataStore()
      dataStore.clearData()
    }
  }
})